export default "__VITE_ASSET__YAmfzfEC__"